var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.files.length > 0)?_c('FileUploadPreview',{attrs:{"file":_vm.files[0]},on:{"delete":function($event){return _vm.$emit('input', null)}}}):_vm._e(),(_vm.files.length == 0)?_c('FileUploadInput',{attrs:{"label":_vm.label},on:{"change":_vm.updateFiles}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }